module.exports = __webpack_public_path__ + "static/media/sSPELL.a8e15bd7.png";